<template>
    <section class="py-6 px-5" v-if="nonMunicipalOffices.length">
        <div class="container is-max-desktop padding-responsive">
            <div class="columns is-multiline">
                <div class="column is-full">
                    <header class="my-4">
                        <h3 class="titulo-bandera">Resultado para esta búsqueda</h3>
                    </header>
                    <p class="has-text-grey-light">{{ nonMunicipalOffices.length }} {{ nonMunicipalOffices.length
                        === 1 ? 'resultado' : 'resultados' }} para esta búsqueda</p>
                </div>
                <div v-for="office in nonMunicipalOffices" class="column is-6-tablet is-4-widescreen">
                    <mex-sucursal-card :office="office"></mex-sucursal-card>
                </div>

            </div>
        </div>
    </section>
</template>
<script>
import MexSucursalCard from './MexSucursalCard.vue';

export default {
    components: {
        MexSucursalCard,
    },
    props: ['filteredOffices'],
    computed: {
        nonMunicipalOffices() {
            return this.filteredOffices.filter(office => !office.is_municipal)
        }
    }
}
</script>